import { Component, Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

import { default as componentAjs } from './agent-view-indicators.component.ajs';

@Directive({
  selector: 'cng-agent-view-indicators-upgrade',
})
export class AgentViewIndicatorsUpgradeComponent extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super(componentAjs, elementRef, injector);
  }
}

@Component({
  selector: 'cng-agent-view-indicators',
  template: '<cng-agent-view-indicators-upgrade></cng-agent-view-indicators-upgrade>',
})
export class AgentViewIndicatorsComponent {}
